import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  status: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  evidenceLoading: {
    minHeight: 180,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  documentDetails: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(0.5),
    border: '1px solid #e3e8ee',
    borderRadius: 8,
    backgroundColor: '#f7f9fb',
  },
  pdfProgress: {
    marginRight: theme.spacing(1),
    color: 'inherit',
  },
  evidenceAnsweredChip: {
    width: 120,
    border: '1px solid #00c853',
    color: '#00a844',
    backgroundColor: '#e6ffed',
    fontSize: '0.8rem',
    padding: '0 4px',
    '&:hover, &:focus': {
      backgroundColor: '#d5f8df',
    },
  },
  evidenceNotRequiredChip: {
    width: 120,
    border: '1px solid #e0e0e0',
    color: '#9e9e9e',
    backgroundColor: '#f5f5f5',
    fontSize: '0.8rem',
  },
  evidencePendingChip: {
    width: 120,
    border: '1px solid #ffc107',
    color: '#856404',
    backgroundColor: '#fff3cd',
    fontSize: '0.8rem',
    padding: '0 4px',
    '&:hover, &:focus': {
      backgroundColor: '#ffe8a1',
    },
  },
  modalTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    fontWeight: 600,
  },
  modalTitleIcon: {
    color: theme.palette.primary.main,
  },
  modalContent: {
    padding: theme.spacing(3),
    backgroundColor: '#eef1f5',
    overflowX: 'hidden',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1),
    },
  },
  documentPaper: {
    width: '100%',
    maxWidth: 820,
    boxSizing: 'border-box',
    margin: '0 auto',
    padding: theme.spacing(4),
    backgroundColor: '#fff',
    border: '1px solid #dfe3e8',
    boxShadow: '0 8px 30px rgba(33, 43, 54, 0.08)',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2.5),
    },
  },
  documentHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    '& > div': {
      minWidth: 0,
    },
  },
  documentEyebrow: {
    color: '#637381',
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 1.6,
    textTransform: 'uppercase',
  },
  documentTitle: {
    marginTop: theme.spacing(0.5),
    color: '#172b4d',
    fontWeight: 700,
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  documentTrainingTitle: {
    marginBottom: theme.spacing(3),
    color: theme.palette.primary.main,
    fontSize: 18,
    fontWeight: 600,
    lineHeight: 1.35,
    textAlign: 'center',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  documentIcon: {
    color: theme.palette.primary.main,
    fontSize: 48,
    opacity: 0.8,
  },
  documentAccent: {
    width: 72,
    height: 4,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: 4,
    backgroundColor: theme.palette.primary.main,
  },
  documentInfo: {
    minWidth: 0,
    height: '100%',
    padding: theme.spacing(1, 1.5),
  },
  documentInfoLabel: {
    color: '#7a869a',
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: 0.7,
    textTransform: 'uppercase',
  },
  documentInfoValue: {
    marginTop: theme.spacing(0.5),
    color: '#172b4d',
    fontSize: 14,
    fontWeight: 500,
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  objectiveBox: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    borderRadius: 8,
    backgroundColor: '#f7f9fb',
  },
  objectiveIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 0 38px',
    width: 38,
    height: 38,
    marginRight: theme.spacing(1.5),
    borderRadius: '50%',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    '& svg': {
      fontSize: 21,
    },
  },
  objectiveContent: {
    minWidth: 0,
  },
  objectiveTitle: {
    marginBottom: theme.spacing(0.5),
    color: '#172b4d',
    fontSize: 16,
    fontWeight: 700,
  },
  objectiveText: {
    color: '#637381',
    lineHeight: 1.6,
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  documentDivider: {
    margin: theme.spacing(1, 0, 3),
  },
  answerSection: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    borderBottom: '1px solid #edf0f2',
  },
  answerNumber: {
    flex: '0 0 38px',
    width: 38,
    height: 38,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    color: theme.palette.primary.main,
    backgroundColor: '#e8f8fc',
    fontSize: 12,
    fontWeight: 700,
  },
  answerContent: {
    minWidth: 0,
    flex: 1,
    overflow: 'hidden',
  },
  answerTitle: {
    color: '#172b4d',
    fontWeight: 600,
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  answerText: {
    maxWidth: '100%',
    marginTop: theme.spacing(1),
    color: '#42526e',
    lineHeight: 1.7,
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  declarationBox: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
    padding: theme.spacing(2.5),
    border: '1px solid #b7e4c7',
    borderRadius: 8,
    backgroundColor: '#f0fbf4',
  },
  declarationIcon: {
    flexShrink: 0,
    color: '#00a844',
    fontSize: 30,
  },
  declarationTitle: {
    color: '#087f3d',
    fontWeight: 700,
  },
  declarationText: {
    marginTop: theme.spacing(0.75),
    color: '#35604a',
    lineHeight: 1.6,
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  documentFooter: {
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(2),
    borderTop: '1px dashed #c7cdd4',
    color: '#7a869a',
    fontSize: 11,
    textAlign: 'center',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
}));
